let langMessages = {
  'ua': {
    'COMMENT_EMAIL': 'E-mail',
    'COMMENT_PUBLISH': 'Опублікувати відповідь',
    'COMMENT_TEXT': 'Повідомлення',
    'COMMENT_NAME': 'ім\'я',
    'COMMENT_OR': 'або',
    'COMMENT_AUTHORIZE': 'авторизуйтесь',
    'COMMENT_PUBLISH_AFTER_MODERATE': 'Дякуємо! Ваш коментар буде опубліковано після модерації.'
  },
  'ru': {
    'COMMENT_EMAIL': 'E-mail',
    'COMMENT_PUBLISH': 'Публиковать ответ',
    'COMMENT_TEXT': 'Cообщение',
    'COMMENT_NAME': 'Имя',
    'COMMENT_OR': 'или',
    'COMMENT_AUTHORIZE': 'авторизируйтесь',
    'COMMENT_PUBLISH_AFTER_MODERATE': 'Спасибо! Ваш комментарий будет опубликован после модерации.'
  }
}

export { langMessages }